/**
 * @Description 配置缓存的页面
 */

export const keepRoutes: any[] = [
  // 登录 -> 用户协议
  { formPathname: '/login', toPathname: ['/login/user-agreement'] },
  { formPathname: '/login', toPathname: ['/login/privacy-agreement'] },
  { formPathname: '/login', toPathname: ['/login/forget-password'] },
  { formPathname: '/login', toPathname: ['/login/change-company'] },
  // 对列表去详情后，需要缓存组件
  {
    formPathname: '/insight/history', // 周边查询历史
    toPathname: ['/insight/search'] // 周边查询历史-搜索页
  },
  {
    formPathname: '/place/list', // 自助选址列表页
    toPathname: ['/place/detail'] // 自助选址详情页
  },
  {
    formPathname: '/join', // 加盟意向
    toPathname: [
      '/join/detail', // 加盟意向详情
    ] // 加盟意向详情
  },
  {
    formPathname: '/join/detail', // 加盟意向详情
    toPathname: [
      '/join/editfollow', // 加盟意向新增或编辑
    ] // 加盟意向详情
  },
  {
    formPathname: '/storemap', // 选址地图
    toPathname: ['/map/searchaddress'] // 选址地图-搜索页
  },
  {
    formPathname: '/collection/businessmap', // 集客点地图
    toPathname: ['/collection/add', '/collection/detail', '/collection'] // 集客点清单详情/去录入/已录入清单
  },
  {
    formPathname: '/collection', // 集客点清单
    toPathname: ['/collection/detail', '/collection/approvenodes'] // 集客点清单详情
  },
  {
    formPathname: '/collection/detail', // 集客点清单详情
    toPathname: ['/collection/approvenodes'] // 节点详情
  },
  {
    formPathname: '/footprinting/home', // 踩点宝
    toPathname: ['/footprinting/detail'] // 踩点宝点位详情页面
  },
  {
    formPathname: '/footprinting/detail', // 踩点宝点位详情页面
    toPathname: ['/footprinting/report'] // 踩点宝任务详情页面
  },
  {
    formPathname: '/footprinting2/tasklist', // 新版踩点任务列表
    toPathname: ['/footprinting2/taskdetail'] // 新版踩点任务详情页面
  },
  {
    formPathname: '/home', // 周边查询历史
    toPathname: ['/home/navigation'] // 周边查询历史-搜索页
  },
  {
    formPathname: '/passenger', // 即插即踩主页
    toPathname: [
      '/passenger/createtask', // 创建任务
      '/passenger/taskdetail', // 任务详情
      '/passenger/analysedetail', // 任务分析详情
      '/passenger/draw', // 绘制
    ]
  },
  {
    formPathname: '/passenger/analysedetail', // 分析详情页
    toPathname: [
      '/passenger/map', // 地图页
    ]
  },
  {
    formPathname: '/iterate/siteselectionmap', // 详情页
    toPathname: [
      '/iterate/neighborhood', // 门店经营
      '/iterate/store', // 周边配套
    ]
  },
  {
    formPathname: '/standardstore/taskStandardAndClusterCreate', // 表单页
    toPathname: [
      '/standardstore/selectfranchisee', // 选择加盟商
    ]
  },
  {
    formPathname: '/standardstore/shopsign', // 门店签约表单页
    toPathname: [
      '/standardstore/selectfranchisee', // 选择加盟商
    ]
  },
  {
    formPathname: '/sitemap', // 选址地图
    toPathname: [
      '/sitemap/filterMap', // 选址地图搜索结果页
      // '/sitemap/collect', // 选址地图收藏页
      '/sitemap/intention', // 意向提报页
      '/sitemap/intentionrecords', // 提报记录列表
      '/sitemap/clusterchancepoints', // 全部机会点
      '/sitemap/clusterstores', // 全部本品牌门店
      // '/sitemap/heatmap', // 选址-热力
      // '/storemap/universal', // 门店地图通用版
      '/collection/addnew', // 集客点去录入
      '/collection/indexnew', // 集客点清单列表
      '/collection/detailnew', // 集客点清单详情
    ]
  },
  {
    formPathname: '/iterate/siteselectionmapdetail', // 选址地图详情页
    toPathname: [
      '/collection/detailnew', // // 集客点清单详情
      '/storeoperate', // 选址地图详情页-查看更多-门店明细
      '/sitemap/clusterchancepoints', // 全部机会点
      '/sitemap/clusterstores', // 全部本品牌门店
    ]
  },
  {
    formPathname: '/sitemap/collect', // 选址地图收藏页
    toPathname: ['/collection/detailnew'] // 集客点清单详情
  },
  {
    formPathname: '/collection/addnew', // 集客点去录入
    toPathname: ['/collection/detailnew'] // 集客点清单详情
  },
  {
    formPathname: '/collection/indexnew', // 集客点清单列表
    toPathname: [
      '/collection/detailnew', // 集客点清单详情
      '/collection/addnew', // 集客点去录入
    ]
  },
  {
    formPathname: '/collection/detailnew', // 集客点清单详情
    toPathname: ['/collection/approvenodes'] // 节点详情
  },
  {
    formPathname: '/sitemap/filterMap', // 选址地图
    toPathname: ['/sitemap/intention'] // 意向提报页
  },
  {
    formPathname: '/spotevaluation/history', // 点位测评历史列表
    toPathname: ['/spotevaluation/detail'] // 点位测评详情
  },
  // {
  //   formPathname: '/spotevaluation/detail', // 点位测评详情
  //   toPathname: ['/storeoperate/spot'] // 门店明细
  // },
  {
    formPathname: '/sitemap/youth', // 选址地图青春版
    toPathname: [
      '/sitemap/heatmap', // 热力图
      // '/sitemap/collect', // 收藏夹（旧）
      '/sitemap/filterMap', // 筛选结果页
      '/collection/addnew', // 集客点去录入
      '/collection/indexnew', // 集客点清单列表
      '/collection/detailnew', // 集客点清单详情
      '/sitemap/intention', // 意向提报页
      '/sitemap/intentionrecords', // 提报记录列表
      '/sitemap/clusterchancepoints', // 全部机会点
      '/sitemap/clusterstores', // 全部本品牌门店
      '/storeoperate/youth', // 选址地图详情页-查看更多-门店明细
      '/sitemap/alltaskdetail', // 选址地图详情页-底部按钮-拓店任务iframe
      '/sitemap/flowfullscreen', // 每日客流趋势横屏页
      '/standardstore/history', // 选址地图详情页-底部按钮-历史拓店任务
      '/spotevaluation/detail', // 点位测评详情
    ]
  },
  {
    formPathname: '/sitemap/ycollect', // 选址地图青春版-收藏页
    toPathname: [
      '/collection/detailnew'
    ],
  },
  {
    formPathname: '/home/search',
    toPathname: [
      '/sitemap/youth',
      '/sitemap/heatmap',
      '/passengerFlow',
      '/collection/businessmap',
      '/chancepoint',
      '/longerpoppupshop/chancepointlist',
      '/passenger',
      '/join',
      '/places',
      '/competitor',
      '/fixedpointshooting',
      '/attendance',
      '/shoprecommend',
      '/spotevaluation',
      '/handwrittennotes'
    ]
  },
  {
    formPathname: '/openingarea', // 开店区域
    toPathname: [
      '/sitemap/youth'
    ],
  },
  {
    formPathname: '/predictflow', // 预估客流
    toPathname: [
      '/predictflow/detail',
      '/passenger',
    ],
  },
  {
    formPathname: '/article', // 文章
    toPathname: [
      '/article/detail'
    ],
  },
  {
    formPathname: '/investment/material', // 招商素材列表
    toPathname: [
      '/investment/material/detail', // 招商素材详情
      '/investment/material/edit', // 招商素材编辑
    ]
  },
  {
    formPathname: '/passengerflowcount/history', // 客流计数-历史记录
    toPathname: [
      '/passengerflowcount/detail'
    ],
  },
  {
    formPathname: '/abside/customerfollowup', // 客户跟进
    toPathname: [
      '/abside/customerdetails', // 客户详情
      '/abside/customeredit', // 新增客户
    ],
  },
  {
    formPathname: '/abside/customerdetails', // 客户详情
    toPathname: [
      '/abside/customeredit', // 编辑客户
    ],
  },
  {
    formPathname: '/abside/week', // 销售周报
    toPathname: ['/abside/weekrecord'], // 周报提交记录
  },
  {
    formPathname: '/abside/weekrecord', // 周报提交记录
    toPathname: ['/abside/weekdetail'], // 周报详情
  },
  {
    formPathname: '/abside/month', // 销售月报
    toPathname: ['/abside/monthrecord'], // 月报提交记录
  },
  {
    formPathname: '/abside/monthrecord', // 月报提交记录
    toPathname: ['/abside/monthdetail'], // 月报详情
  },
];

/**
 * 场景描述
 * A、B、C三个页面，A和B都需要缓存，但是每次从A到B的时候，B需要刷新，从C返回B时，B是缓存状态，配置A(formPathname)和B(toPathname)的路由
 * 比如下方的 /join和/join/detail页面其实都在keepRoutes配置并且需要缓存
 * 但是交互为：
 *  1、如果是从并且仅从/join/detail返回到/join，/join需要缓存
 *  2、如果是从并且仅从/join/editfollow返回到/join/detail，/join/detail需要缓存
 * 此时需要配置此参数，否则 /join跳转至 /join/detail同样会被缓存。
 */
export const clearInKeepRoutes: any[] = [
  {
    formPathname: '/collection/businessmap', // 集客点地图
    toPathname: '/collection' // 集客点清单列表
  },
  {
    formPathname: '/passenger', // 踩点宝首页
    toPathname: '/passenger/analysedetail' // 拍摄记录分析详情页
  },
  {
    formPathname: '/join', // 加盟意向
    toPathname: '/join/detail' // 加盟意向详情
  },
  {
    fromPathname: '/home/search', // 首页搜索
    toPathname: '/sitemap/youth', // 地图
  }
];
